module.exports = __webpack_public_path__ + "static/media/cartWhite.99b8d0a5.svg";